<h2>Range Settings</h2>

<span *ngIf="startDate && endDate">{{startDate}} - {{endDate}}</span>

  <form [formGroup]="rangeForm">
    <mat-dialog-content>

      <mat-form-field class="range">
        <mat-select (selectionChange)="onRangeChange($event.value)" formControlName="range" placeholder="Select Range">
          <mat-option *ngFor="let range of ranges" class="rangeOption" [value]="range.value">
            {{range.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <input matInput [ngxMatDatetimePicker]="pickerFrom" (dateChange)="onDateTimeChange($event.value, true)" (input)="onDateTimeChange($event.target.value, true)" placeholder="Choose a date" formControlName="fromDate"
          [min]="minDateFrom" [max]="maxDateFrom" [disabled]="disabled">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #pickerFrom [showSpinners]="showSpinners" [showSeconds]="showSeconds"
          [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
          [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian">
        </ngx-mat-datetime-picker>
      </mat-form-field>

      <!-- <mat-form-field>
        <input matInput (dateChange)="onDateTimeChange($event.value, true)"
          [ngxMatDatetimePicker]="pickerFrom" placeholder="From date" formControlName="fromDate" [min]="minDateFrom"
          [max]="maxDateFrom" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom">
        </mat-datepicker-toggle>
        <ngx-mat-datetime-picker #pickerFrom [showSpinners]="showSpinners" [showSeconds]="showSeconds"
          [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond" (click)="pickerTo.open()" [color]="color">
        </ngx-mat-datetime-picker>
      </mat-form-field> -->

      <mat-form-field>
        <input matInput [ngxMatDatetimePicker]="pickerTo" (dateChange)="onToDateChange($event.value)" (input)="onToDateChange($event.target.value)" (focusOut)="$event.preventDefault()" placeholder="Choose a date" formControlName="toDate"
          [min]="minDateTo" [max]="maxDateTo" [disabled]="disabled">
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #pickerTo [showSpinners]="showSpinners" [showSeconds]="showSeconds"
          [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
          [touchUi]="touchUi" [color]="color">
        </ngx-mat-datetime-picker>
      </mat-form-field>

      <!-- <mat-form-field>
        <input matInput (dateChange)="onDateTimeChange($event.value)"
          [ngxMatDatetimePicker]="pickerTo" placeholder="To date" formControlName="toDate" [min]="minDateTo"
          [max]="maxDateTo" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="pickerTo">
        </mat-datepicker-toggle>
        <ngx-mat-datetime-picker #pickerTo [showSpinners]="showSpinners" [showSeconds]="showSeconds"
          [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond" [color]="color" (click)="pickerTo.open()">
        </ngx-mat-datetime-picker>
      </mat-form-field> -->

    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button [mat-dialog-close]="false" style="background-color: gray;">Cancel</button>
      <button mat-raised-button color="primary" (click)="submit()" [disabled]="!isFormValid"
        class="apply-btn">Apply</button>
    </mat-dialog-actions>
  </form>